import React from 'react';

import {Helmet} from 'views/module';

import CaseMonitor from 'views/scenes/case/monitor/CaseMonitor';

const CaseMonitorPage = (props) => {
  return (
    <>
      <Helmet>
        <title>Quilt: Case monitor</title>
      </Helmet>
      <CaseMonitor />
    </>
  );
};

export default CaseMonitorPage;
